import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query plans($from: String!, $to: String!) {
    plans(from: $from, to: $to) {
      id
      date
      meal
      amount
      unit {
        name
        sign
      }
      user {
        email
      }
      dish {
        id
        name
        recipe
      }
    }
  }
`;

const usePlans = (from, to) => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    skip: !from || !to,
    variables: { from, to },
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.plans };
};

export default usePlans;
